// extracted by mini-css-extract-plugin
export var alertCards = "_3-0";
export var card = "_3-1";
export var fade = "_3-2";
export var hidden = "_3-3";
export var progressBar = "_3-4";
export var roundtime = "_3-5";